module.exports = __webpack_public_path__ + "img/vps.d9f7d62.svg";